import {CaptchaResponse, IdName} from '@core/src/public-api';
import {HealthCard, IdentityDocument, Phone} from './register.model';

export class AppointmentRequestRequirements {
  collective?: any; //IdName | number;
  center?: any; //IdName | number;
  type?: string;
  service?: any; //IdName | number;
  professional?: any; //IdName | number;
  appointmentReason?: any; //IdName | number;
  newAppointmentDate?: number;
  timePreference?: any; //IdName | number;
  reason?: string;
  fromDate?: number;
  privateInsurance?: boolean;
  searchBy?: string;

  constructor() {
    this.appointmentReason = [null];
  }
}

export class AppointmentRequest extends AppointmentRequestRequirements {
  blockHourId?: number;
  centerName?: string;
  endDate?: number;
  guarantor?: IdName;
  professionalName?: string;
  serviceName?: string;
  startDate?: number;
  schedule?: IdName;
  emailNotification?: boolean;
  smsNotification?: boolean;
  appointmentId?: number;
  oldAppointmentId?: number;
  reserveId?: number;
  refreshUserRole?: boolean;
  proposalId?: number;
  teleconsultation?: boolean = false; // Default false until PCS-170
  slotSelected?: AppointmentRequestSelector;
  // Identification
  hasVisitedBefore?: boolean;
  firstName?: string;
  surname1?: string;
  surname2?: string;
  identityDocument: IdentityDocument;
  healthCardDocument: HealthCard;
  email?: string;
  emailConfirm?: string;
  phone?: Phone;
  birthDate?: number;
  gender?: IdName;
  notificationLanguage?: string;
  password?: string;
  passwordConfirm?: string;
  nhc?: string;
  acceptPolicy?: boolean;
  acceptContactData?: boolean;
  verificationCode?: string;
  captchaResponse?: CaptchaResponse;
  resetCaptcha?: number;

  constructor() {
    super();
  }
}

export class AppointmentRequestSelector extends IdName {
  appointmentRequest?: AppointmentRequest;
}
